import Spacer from '@/common/components/spacer';
import React, { ReactNode } from 'react';
import EngineIcon from '@/icons/engine-icon';
import { SeatIcon } from '@/icons/seat-icon';
import CarActionsMusicIcon from '@/icons/car-actions-music';
import { Features } from '../types';
export interface FeatureCategory {
  title: string;
  icon: ReactNode;
  features: string[];
}

interface VehicleAdditionalInfoProps {
  features: Features;
}

function VehicleAdditionalInfo({ features }: VehicleAdditionalInfoProps) {
  const featuresCategory: FeatureCategory = {
    title: 'Features',
    icon: <EngineIcon />,
    features: features.features,
  };

  const interiorCategory: FeatureCategory = {
    title: 'Interior',
    icon: <SeatIcon />,
    features: features.interior,
  };

  const accessoriesCategory: FeatureCategory = {
    title: 'Accessories',
    icon: <CarActionsMusicIcon />,
    features: features.accessories,
  };

  const categorizedFeatures = [featuresCategory, interiorCategory, accessoriesCategory];

  const categorizedFeatureElements = categorizedFeatures.map((item, index) => {
    return (
      item.features.length > 0 && (
        <React.Fragment key={item.title}>
          <div className="mt-10 inline-block w-full rounded-2xl bg-background p-6 font-medium md:min-w-[410px] md:max-w-[410px]">
            <div className="flex">
              {item.icon}
              <div className="pl-2">{item.title}</div>
            </div>
            <div className="mt-2 h-px w-full bg-flexcar-neutral80" />
            <div className="mt-2 font-normal">
              <ul className="ml-4">
                {item.features.map((feature, index) => {
                  return <li key={index}>{feature}</li>;
                })}
              </ul>
            </div>
          </div>
          {index !== categorizedFeatures.length - 1 ? <Spacer variant="width4" /> : null}
        </React.Fragment>
      )
    );
  });
  return (
    <div className="md:scrollbar-hidden w-full overflow-x-auto md:overflow-visible md:overflow-x-auto">
      <div className="flex w-full flex-col gap-[0px] md:flex-row md:justify-start md:gap-[8px]">
        {categorizedFeatureElements}
      </div>
    </div>
  );
}

export default VehicleAdditionalInfo;
